import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import Routes from 'apps/portal/routes.erb';
import LayoutHeader from 'shared/layout-header';
import LayoutContainer from 'shared/layout-container';

import './styles.pcss';

const propTypes = {
  headerButtons: PropTypes.node,
  title: PropTypes.node,
  footerText: PropTypes.node,
  children: PropTypes.node,
};
const defaultProps = {
  headerButtons: null,
  title: null,
  footerText: null,
  children: null,
};

export default function AuthLayout({
  headerButtons,
  title,
  footerText,
  children,
}) {
  return (
    <Fragment>
      <Helmet>
        <title>Fountain{title && ` - ${title}`}</title>
      </Helmet>
      <LayoutHeader
        logoHref={Routes.portal_dashboard_path()}
        sectionRight={headerButtons}
      />
      <LayoutContainer className="auth-layout__panel" centered size="xsmall">
        {title && <h2 className="auth-layout__heading">{title}</h2>}
        {children}
        {footerText && <footer className="auth-layout__footer-text">{footerText}</footer>}
      </LayoutContainer>
    </Fragment>
  );
}

AuthLayout.propTypes = propTypes;
AuthLayout.defaultProps = defaultProps;
